export class CallCheckListPayload {
  additionalEmergency!: string; 
  additionalOutsideLocation!: string; 
  appliance!: string; 
  buildingSelected!: string; 
  callerTypes!: string;  
  isLeakAppliance!: string;
  isLeakHousePiping!: string;
  leakageType!: string;  
  leakedSelected!: string; 
  odorfirstnoticed!: string;  
  room!: string; 
  soundGas!: string;
  type!: string;
  workInProgress!: string;
  }